module.exports = __webpack_public_path__ + "static/media/trivvy-logo-txt.b918f297.png";